import {FC} from 'react'
import {useIntl} from 'react-intl'
import {CDRTable} from './table/CDRTable'
import {useParams} from 'react-router-dom'
import {KTCard} from '../../template/helpers'
import {CDRHeader} from './components/CDRHeader'
import {appsAPI} from '../../services/AppsService'
import {PageTitle} from '../../template/layout/core'
import {EmptyCDRPage} from './components/EmptyCDRPage'
import {CDREntitiesProvider} from './hooks/useQueryCDRUsersRequest'
import {QueryRequestProvider} from '../../template/helpers/QueryRequestProvider'
import {useRedirectOnAccountSwitch} from '../../hooks/useRedirectOnAccountSwitch'

export const CDRTableWrap = () => {
  return (
    <KTCard className='shadow-sm'>
      <CDRHeader />
      <CDREntitiesProvider>
        <CDRTable />
      </CDREntitiesProvider>
    </KTCard>
  )
}

const CDRPage: FC = () => {
  const intl = useIntl()
  const {appId} = useParams()
  useRedirectOnAccountSwitch('/cdr/')
  const {data: app, isLoading, error} = appsAPI.useFetchAppByIdQuery(appId!)

  if (app === null || error) {
    return <EmptyCDRPage error={error} />
  }

  return (
    <>
      {isLoading ? (
        <>
          <PageTitle>{intl.formatMessage({id: 'APPS.CDR'})}</PageTitle>
          <span className='indicator-progress' style={{display: 'block'}}>
            {intl.formatMessage({id: 'WAIT'})}
            <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
          </span>
        </>
      ) : (
        <>
          <PageTitle>{intl.formatMessage({id: 'APPS.CDR'}) + ' - ' + app?.crm_domain}</PageTitle>
          <QueryRequestProvider>
            <CDRTableWrap />
          </QueryRequestProvider>
        </>
      )}
    </>
  )
}

export default CDRPage
